import { forgotPassword } from './pages/forgotPassword';
import { geolocationDenied } from './pages/geolocationDenied';
import { login } from './pages/login';
import { validateToken } from './pages/validateToken';

export const es = {
  pages: {
    login,
    forgotPassword,
    geolocationDenied,
    validateToken,
  },
  components: {
    languageSwitch: {
      label: 'Cambiar idioma',
      pt: 'Portugués',
      en: 'Inglés',
      es: 'Español',
    },
    servicesSelection: {
      title: 'Seleccionar servicios',
      selectAtLeastOne: 'Seleccione al menos un servicio',
      next: 'Siguiente',
    },
    additionalFields: {
      title: 'Campos Adicionales',
      back: 'volver',
      zipLabel: 'Código postal',
      phoneLabel: 'Teléfono',
      emailLabel: 'E-mail',
      next: 'Siguiente',
      zipRequired: '¡El código postal es obligatorio!',
      phoneRequired: '¡El teléfono es obligatorio!',
      emailRequired: '¡El e-mail es obligatorio!',
    },
    bodyStep: {
      identificationBy: 'Identificación por {{validation}}',
      companyLabel: 'Empresa:',
      userLabel: 'Usuario:',
      signOut: 'Salir',
      versionLabel: 'Versión:',
      apiVersionLabel: 'Versión de la API:',
      providerLabel: 'Provisto por:',
      stepMeta: 'Etapa {{current}} de {{total}}',
      back: 'Volver',
    },
    summary: {
      title: 'Resumen de la atención',
      openButton: 'Ver resumen',
      close: 'Cerrar',
      analysisTypeLabel: 'Tipo de análisis',
      analysisTypeCnh: 'DNI/Pasaporte + foto',
      analysisTypeFace: 'Foto del rostro',
      analysisTypeData: 'Datos informados',
      analysisTypePj: 'Persona Jurídica',
      nameLabel: 'Nombre',
      documentLabel: 'Documento',
      servicesLabel: 'Servicios seleccionados',
      allServices: 'Todos los servicios contratados',
      findingsCount: 'Observaciones encontradas en este servicio',
      outcomeFindings: 'Este servicio encontró observaciones',
      outcomeFailed: 'La consulta de este servicio falló — resultado no obtenido',
      outcomeClean: 'Este servicio no encontró observaciones',
      empty: 'Aún no informado',
    },
    camera: {
      title: 'Foto',
      back: 'volver',
      clear: 'LIMPIAR',
      next: 'SIGUIENTE',
      uploadImage: 'SUBIR IMAGEN',
      camera: 'CÁMARA',
      takePhoto: 'TOMAR FOTO',
    },
    choose: {
      title: 'Seleccionar método de análisis',
      back: 'volver',
      photoOption: 'Análisis por foto',
      cnhOption: 'Análisis por foto de DNI/Pasaporte',
      faceOption: 'Análisis por foto de rostro',
      dataOption: 'Análisis por Datos Informados',
    },
    flowChooser: {
      title: '¿Qué necesita consultar?',
      pfTitle: 'Consultas Persona Física',
      pjTitle: 'Consultas Persona Jurídica',
      description:
        'Realice una búsqueda completa basada en las consultas previamente autorizadas por su empresa',
      unavailable:
        'Opción disponible para contratación. Hable con nuestro equipo comercial.',
    },
    companyIdentification: {
      title: 'Datos de la Empresa',
      back: 'volver',
      documentLabel: 'CNPJ',
      documentPlaceholder: '00.000.000/0000-00',
      next: 'Consultar',
      documentInvalid: 'CNPJ inválido',
      requestFailed:
        'No fue posible completar la consulta. Inténtelo de nuevo.',
    },
    identification: {
      title: 'Datos Personales',
      back: 'volver',
      nameLabel: 'Nombre completo',
      birthLabel: 'Fecha de nacimiento',
      documentTypeLabel: 'Tipo de documento',
      documentNumberLabel: 'Número de documento',
      next: 'Siguiente',
      nameRequired: '¡El nombre es obligatorio!',
      birthRequired: '¡La fecha de nacimiento es obligatoria!',
      documentInvalid: 'Documento inválido',
    },
    instructions: {
      title: 'Instrucciones',
      back: 'volver',
      next: 'Siguiente',
      selfie: {
        faceVisible: 'Tómate una selfie con el rostro de frente y visible',
        goodLighting: 'Busca una buena iluminación',
        removeAccessories: 'Quita accesorios como gafas y sombrero',
        avoidRotation: 'Evita rotar la cámara del dispositivo',
      },
      document: {
        flatSurface: 'Apoya el documento sobre una superficie plana',
        goodLighting: 'Busca una buena iluminación',
        adjustFocus: 'Ajusta el enfoque para garantizar la calidad',
        avoidRotation: 'Evita rotar la cámara del dispositivo',
      },
    },
    result: {
      title: 'Resultado',
      fullName: 'Nombre completo',
      document: 'Documento',
      failureMessage: 'Hubo un fallo en la consulta. Inténtelo de nuevo.',
      biometryLabel: 'Biometría facial',
      findingsOverview: {
        withServices: 'observación(es) encontrada(s) en:',
        total: 'observación(es) encontrada(s) en esta consulta.',
      },
      status: {
        recommended: 'SIN OBSERVACIONES',
        notRecommended: 'CON OBSERVACIONES',
        failed: 'FALLO',
      },
      process: {
        subject: 'Asunto',
        branch: 'Área',
        type: 'Tipo de proceso',
        judgingBody: 'Expedido por',
        defendands: 'Demandados',
        date: 'Fecha de expedición',
        status: 'Estado',
        lawsuitNr: 'Número de proceso',
        value: 'Valor de la causa',
      },
      buttons: {
        returnToPlatform: 'Volver a la plataforma SGRLOC',
        tryAgain: 'Intentar de nuevo',
        backToStart: 'Volver al inicio',
      },
    },
    resultDetails: {
      notInformed: 'No informado',
      titles: {
        score: 'Score de crédito',
        dados_pj: 'Datos de la empresa',
        validacao_pj: 'Situación registral',
      },
      score: {
        classLabel: 'Clase',
        pointsLabel: 'Puntuación',
        bandScalePf: 'rangos — persona física',
        bandScalePj: 'rangos — persona jurídica',
        restrictionsTitle: 'Restricciones',
        debts: 'Deudas',
        protests: 'Protestos',
        checks: 'Cheques',
        recordsCount: '{{count}} registro(s)',
        incomePresumed: 'Renta presunta',
        revenueEstimated: 'Facturación estimada',
        notProven: 'Estimación del proveedor, no comprobada',
        consultDate: 'Obtenido el',
        disclaimer:
          'La puntuación es informativa: la observación depende solo de las restricciones. Utilícela exclusivamente como apoyo en el proceso de decisión.',
      },
      company: {
        registrationSection: 'Datos registrales',
        corporateName: 'Razón social',
        tradeName: 'Nombre comercial',
        openingDate: 'Fecha de apertura',
        companyAge: 'Antigüedad de la empresa',
        companyAgeValue: '{{years}} año(s)',
        registrationStatus: 'Situación registral',
        registrationStatusDate: 'Fecha de la situación',
        size: 'Tamaño',
        legalNature: 'Naturaleza jurídica',
        cnae: 'CNAE',
        partners: 'Socios',
        partnerSince: 'desde {{date}}',
        addresses: 'Direcciones',
        phones: 'Teléfonos',
        phoneMobile: 'móvil',
        phoneLandline: 'fijo',
        emails: 'E-mails',
      },
    },
    optIn: {
      title: 'Términos de Uso',
      checkboxText: 'He leído y acepto estos términos y condiciones',
      buttons: {
        accept: 'Aceptar',
        refuse: 'Rechazar',
      },
    },
    faceTecCamera: {
      back: 'volver',
      titleCaptured: 'Foto capturada',
      titleDefault: 'Foto',
      buttons: {
        clear: 'LIMPIAR',
        next: 'SIGUIENTE',
        startCamera: 'INICIAR CÁMARA',
      },
      loadingCapture: 'Cargando la captura',
      capturedAlt: 'Foto capturada',
    },
    loading: {
      alt: 'Cargando...',
    },
    dropzone: {
      documentAlt: 'Imagen del documento',
      placeholder: 'Seleccione su documento',
      fileTooLarge: 'El tamaño máximo de la imagen debe ser de 1Mb',
    },
    logos: {
      sgrLoc: 'Logo de SGRLoc',
      swint: 'Logo de Odeen',
    },
  },
};

export default es;
